import Header from '../Header';
import React, { useEffect, useState, useRef } from 'react';
import Footer from '../Footer';
import axios from 'axios';
import ProductImageGallery from '../ProductImageGallery';
import ProductDiscountImage from '../ProductDiscountImage';
import '../../styles/product-image-gallery.css';
import { Link, useHistory } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useBasketStore } from '../../store/Basket';
import { useFavoriteProductsStore } from '../../store/FavoriteProducts';
import Basket from '../Basket';
import ProductStatus from '../ProductStatus';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Helmet } from 'react-helmet';
import { BASE_URL, incrementProductViewCount } from '../../shared/constants.js';
import { availableOrderQuantity, canOrderOnDemand, basketQuantityLimit } from '../../utils/orderAvailability';
import { productImagePaths } from '../../utils/productImages';

const PRODUCT_STATES_FOR_EDIT = [
  { value: 'ACTIVE', label: 'Доступний для замовлення' },
  { value: 'OUT_OF_STOCK', label: 'Тимчасово недоступний' },
  { value: 'SOLD_OUT', label: 'Знятий з продажу' },
  { value: 'PREORDER', label: 'Передзамовлення' },
  { value: 'INACTIVE', label: 'Не активний' }
];

const ProductPage = props => {
  const history = useHistory();

  const addProductToCart = useBasketStore(state => state.addProduct);
  const patchProduct = useBasketStore(state => state.patchProduct);

  const [productInfo, setProductInfo] = useState({});
  const [carouselImages, setCarouselImages] = useState([]);
  const [user, setUser] = useState({});
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [quantity, setQuantity] = useState(1);

  const token = localStorage.getItem('token');

  const [productIdsInCart, setProductIdsInCart] = useState([]);
  const cartProducts = useBasketStore(state => state.products);

  const [showModal, setShowModal] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showThumbnails, setShowThumbnails] = useState(true);
  const [isFavorite, setIsFavorite] = useState(false);
  const [favoriteMessage, setFavoriteMessage] = useState('');
  const [showStatusDropdown, setShowStatusDropdown] = useState(false);
  const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);
  const statusDropdownRef = useRef(null);
  const addFavoriteProduct = useFavoriteProductsStore(state => state.addFavoriteProduct);
  const removeFavoriteProduct = useFavoriteProductsStore(state => state.removeFavoriteProduct);
  const setFavoriteProductIds = useFavoriteProductsStore(state => state.setFavoriteProductIds);
  const favoriteProductIds = useFavoriteProductsStore(state => state.favoriteProductIds);
  const Toggle = () => setShowModal(!showModal);

  useEffect(() => {
    window.scrollTo(0, 0);
    getProductInfo();
    defineQuantityFromCart();
    if (!token) {
      return;
    }
    axios
      .get('/api/v1/auth/current-user', {
        headers: {
          Authorization: token,
        },
      })
      .then(res => {
        if (res.status === 200) {
          setUser(res.data.data);
          setIsLoggedIn(true);
        }
      }).catch(function(error) {
    });
  }, []);

  useEffect(() => {
    const productIdsInCart = cartProducts.map(product => product.id);
    setProductIdsInCart(productIdsInCart);
    defineQuantityFromCart(productInfo.id);
  }, [cartProducts]);

  useEffect(() => {
    if (productInfo && productInfo.name) {
      document.title = `Купити ${productInfo.name} з доставкою по Україні.`;
    }
  }, [productInfo]);

  const defineQuantityFromCart = (currentProductId) => {
    const cartProduct = cartProducts.find(cartProduct => cartProduct.id === currentProductId);
    if (cartProduct !== undefined && cartProduct !== null) {
      setQuantity(cartProduct.quantity);
    }
  }

  const defineShowThumbnails = (productInfo) => {
    setShowThumbnails(productInfo.imagePathList.length > 1);
  }

  const getProductInfo = () => {
    setCarouselImages([]);
    const productId = props.match.params.id;
    axios.get('/api/v1/product/' + productId, {
      headers: {
        Authorization: token,
      },
    }).then(res => {
      const productInfo = { ...res.data.data, imagePathList: productImagePaths(res.data.data) };
      setProductInfo(productInfo);
      if (productInfo.favorite !== undefined) {
        setIsFavorite(productInfo.favorite);
        // Оновлюємо store з ID для локальної перевірки статусу (без оновлення кількості)
        if (productInfo.favorite && !favoriteProductIds.includes(productInfo.id)) {
          setFavoriteProductIds([...favoriteProductIds, productInfo.id]);
        } else if (!productInfo.favorite && favoriteProductIds.includes(productInfo.id)) {
          setFavoriteProductIds(favoriteProductIds.filter(id => id !== productInfo.id));
        }
      }
      const images = productInfo.imagePathList || [];
      setCarouselImages(images.map(img => ({
        original: BASE_URL + '/api/v1/product/image/' + img,
        thumbnail: BASE_URL + '/api/v1/product/image/' + img,
      })));
      defineQuantityFromCart(productInfo.id);
      defineShowThumbnails(productInfo);
      incrementProductViewCount(productInfo.id);
    });
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (statusDropdownRef.current && !statusDropdownRef.current.contains(e.target)) {
        setShowStatusDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const updateProductStatus = (newState) => {
    if (!productInfo?.id || !token) return;
    setIsUpdatingStatus(true);
    axios
      .put('/api/v1/product', { productId: productInfo.id, state: newState }, { headers: { Authorization: token } })
      .then(() => {
        setShowStatusDropdown(false);
        getProductInfo();
      })
      .catch(() => {})
      .finally(() => setIsUpdatingStatus(false));
  };

  const onChangeQuantity = (add) => {
    let resultQuantity = add ? quantity + 1 : quantity - 1;
    const limit = basketQuantityLimit(productInfo, user.type === 'ADMIN');
    if (resultQuantity >= 1 && resultQuantity <= limit) {
      setQuantity(resultQuantity);
      setShowTooltip(false);
      if (productIdsInCart.includes(productInfo.id)) {
        const cartProduct = {
          ...cartProducts.find(product => product.id === productInfo.id),
          id: productInfo.id,
          image: productImagePaths(productInfo)[0] || '',
          name: productInfo.name,
          price: productInfo.price,
          discountedPrice: productInfo.discountedPrice,
          personalDiscount: productInfo.personalDiscount,
          productDiscount: productInfo.productDiscount,
          quantity: resultQuantity,
          maxQuantity: productInfo.quantity,
          state: productInfo.state,
          stockQuantity: productInfo.stockQuantity,
          preorderQuantity: productInfo.preorderQuantity,
          dateAdded: Date.now(),
          toOrder: resultQuantity > availableOrderQuantity(productInfo),
          expectedArrivalDate: productInfo.expectedArrivalDate || null
        }
        const product = { ...cartProduct, quantity: resultQuantity };
        patchProduct(product);
      }
    }
    if (resultQuantity > limit) {
      setShowTooltip(true);
    }
  };

  const renderPrice = () => {
    if (productInfo === undefined) {
      return;
    }

    if (productInfo.price === productInfo.discountedPrice) {
      return (
        <h4 className='mr-1'><strong>{productInfo.price}грн</strong></h4>
      );
    } else if (productInfo.discountedPrice < productInfo.price) {
      return (
        <h4>
          <strong>{productInfo.discountedPrice}грн{' '}</strong>
          <strike style={{ textDecoration: 'line-through' }} className='mr-1'>{productInfo.price}грн</strike>{' '}
        </h4>
      );
    }
  };

  const renderLoginInfo = () => {
    if (!isLoggedIn) {
      return (
        <div className='small mb-1'>
          <i className='bi bi-percent mr-1'></i>
          <Link to='/login' className='text-dark font-weight-bold'>
            Увійдіть
          </Link>
          <span className='text-dark'> для відображення накопичувальної знижки</span>
        </div>
      );
    }
  };

  const renderDiscountInfo = (showText) => {
    let text = '';
    let tooltipText = '';

    if (productInfo.personalDiscount >= productInfo.productDiscount && isLoggedIn) {
      let discountCategoryText = productInfo.discountCategoryName ? 'Категорія для знижки - ' + productInfo.discountCategoryName : '';
      if (isLoggedIn && productInfo.personalDiscount === 0) {
        tooltipText = 'Для цього товару накопичувальна знижка не застосовується. ' + discountCategoryText;
      } else {
        tooltipText = 'На товар дія ваша накопичувальна знижка. ' + discountCategoryText ;
      }
      if (showText) {
        text = 'Накопичувальна знижка';
      }
      return (
        <p className='small font-weight-bold mb-1'>
          <OverlayTrigger placement='top' overlay={<Tooltip id='tooltip'>
            <strong>{tooltipText}</strong>
          </Tooltip>}>
            <span className='badge badge-dark cursor-pointer mr-1'>
              {productInfo.personalDiscount}%</span>
          </OverlayTrigger>
          {text}
        </p>
      );
    }

    if (productInfo.productDiscount > productInfo.personalDiscount) {
      let tooltipMessage = 'На товар діє акційна знижка';
      if (isLoggedIn) {
        tooltipMessage = tooltipMessage + ', яка більша за вашу персональну знижку ' + productInfo.personalDiscount + ' %';
      }
      if (productInfo.state === 'PREORDER') {
        tooltipMessage = 'На товар діє знижка за передзамовленням';
      }
      if (showText) {
        text = productInfo.state === 'PREORDER' ? 'Знижка за передзамовленням' : 'Акційна знижка';
      }
      return (
        <p className='small font-weight-bold mb-1'>
          <OverlayTrigger placement='top' overlay={<Tooltip id='tooltip'>
            <strong>{tooltipMessage}</strong>
          </Tooltip>}>
            <span className='badge badge-danger cursor-pointer mr-1'>
              {productInfo.productDiscount}%</span>
          </OverlayTrigger>
          {text}
        </p>
      );
    }
  };

  const renderBuyBlock = () => {
    if (productInfo.state === 'INACTIVE') return null;
    if (productInfo.quantity > 0 || canOrderOnDemand(productInfo, user.type === 'ADMIN')) {
      return (
        <div className='input-group text-center align-items-center disable-select pt-1'>
                <span
                  onClick={() => onChangeQuantity(false)}
                  className='product-minus bg-dark mr-1'
                > -
                </span>
            <input type='number' id='quantity' name='quantity' className='count'
                   value={quantity}
                   max={basketQuantityLimit(productInfo, user.type === 'ADMIN')} readOnly />
            <OverlayTrigger placement='top' overlay={showTooltip ? (<Tooltip id='tooltip'>
              <strong>Обрано максимальну кількість, більше немає в наявності</strong>
            </Tooltip>) : (<div/>)}>
            <span
              onClick={() => onChangeQuantity(true)}
              className='product-plus bg-dark ml-1'
            > +
          </span>
            </OverlayTrigger>
          {renderBuyButton()}
        </div>
      );
    } else if (productInfo.quantity === 0 && productInfo.state !== 'SOLD_OUT' && productInfo.state !== 'OUT_OF_STOCK') {
      return (
        <div className='input-group text-center align-items-center disable-select pt-1'>
          <a
            href='https://t.me/waaaghShopAdmin' target='_blank' rel='noopener noreferrer'>
            <button
              type='button'
              className='btn btn-warning'
            >
              Привезти "під замовлення"
            </button>
          </a>
        </div>
      );
    }
  };

  const handleFavoriteToggle = () => {
    if (!isLoggedIn) {
      setFavoriteMessage('Увійдіть на сайт, щоб додати товар в обране');
      return;
    }

    // Якщо товар вже в обраному, перекидаємо в персональний кабінет
    if (isFavorite) {
      history.push('/user/personal-cabinet?tab=favorites');
      return;
    }

    // Якщо товар не в обраному, додаємо його
    const productId = productInfo.id;
    const url = `/api/v1/product-favorite/product/${productId}`;

    axios({
      method: 'post',
      url: url,
      headers: {
        Authorization: token
      }
    })
      .then(res => {
        setIsFavorite(true);
        addFavoriteProduct(productId);
      })
      .catch(error => {
        console.error('Error adding to favorites:', error);
        setFavoriteMessage('Не виходить додати товар в обране');
      });
  };

  const handleRemoveFromFavorites = (e) => {
    e.stopPropagation(); // Запобігаємо виклику handleFavoriteToggle
    if (!isLoggedIn) {
      return;
    }

    const productId = productInfo.id;
    const url = `/api/v1/product-favorite/product/${productId}`;

    axios({
      method: 'delete',
      url: url,
      headers: {
        Authorization: token
      }
    })
      .then(res => {
        setIsFavorite(false);
        removeFavoriteProduct(productId);
      })
      .catch(error => {
        console.error('Error removing from favorites:', error);
        setFavoriteMessage('Не виходить видалити товар з обраного');
      });
  };

  const renderFavoriteButton = () => {
    if (isFavorite) {
      // Якщо товар в обраному, робимо текст і сердечко посиланням на персональний кабінет
      return (
        <div 
          className='d-flex align-items-center mt-3'
          style={{ position: 'relative' }}
        >
          <div 
            className='d-flex align-items-center'
            onClick={handleFavoriteToggle}
            style={{ cursor: 'pointer' }}
          >
            <div
              className='mr-2'
              style={{ 
                color: '#dc3545',
                fontSize: '1.5rem',
                lineHeight: '1',
                transition: 'color 0.2s ease'
              }}
            >
              <i className='bi bi-heart-fill'></i>
            </div>
            <div className='d-flex flex-column'>
              <span 
                className='text-danger font-weight-bold'
                style={{ fontSize: '0.95rem', fontWeight: '500' }}
              >
                Товар додано в обране
              </span>
              {favoriteMessage && (
                <small 
                  className='text-warning mt-1'
                  style={{ fontSize: '0.8rem' }}
                >
                  {favoriteMessage}
                </small>
              )}
            </div>
          </div>
          {/* Іконка хрестика для видалення */}
          <button
            type='button'
            onClick={handleRemoveFromFavorites}
            className='btn p-0 border-0 bg-transparent'
            style={{ 
              color: '#dc3545',
              fontSize: '1.05rem',
              lineHeight: '1',
              cursor: 'pointer',
              padding: '0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              alignSelf: 'flex-start',
              marginTop: '2px',
              marginLeft: '0.1rem',
              transition: 'opacity 0.2s ease',
              transform: 'scale(1.1)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.opacity = '0.7';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.opacity = '1';
            }}
            title='Прибрати з обраного'
          >
            <i className='bi bi-x' style={{ 
              WebkitTextStroke: '0.5px #dc3545',
              textShadow: '0.5px 0 0 #dc3545, -0.5px 0 0 #dc3545, 0 0.5px 0 #dc3545, 0 -0.5px 0 #dc3545'
            }}></i>
          </button>
        </div>
      );
    }

    // Якщо товар не в обраному, показуємо звичайну кнопку додавання
    return (
      <div 
        className='d-flex align-items-center mt-3'
        onClick={handleFavoriteToggle}
        style={{ cursor: 'pointer' }}
      >
        <div
          className='mr-2'
          style={{ 
            color: '#6c757d',
            fontSize: '1.5rem',
            lineHeight: '1',
            transition: 'color 0.2s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = '#dc3545';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = '#6c757d';
          }}
        >
          <i className='bi bi-heart'></i>
        </div>
        <div className='d-flex flex-column'>
          <span 
            className='text-muted font-weight-bold'
            style={{ fontSize: '0.95rem', fontWeight: '400' }}
          >
            Додати в обране
          </span>
          {favoriteMessage && (
            <small 
              className='text-warning mt-1'
              style={{ fontSize: '0.8rem' }}
            >
              {favoriteMessage}
            </small>
          )}
        </div>
      </div>
    );
  };

  const renderBuyButton = () => {
    const canBuy = productInfo.quantity > 0 || canOrderOnDemand(productInfo, user.type === 'ADMIN');
    if (productIdsInCart.includes(productInfo.id) && canBuy) {
      return (
        <button type='button' className='btn btn-dark ml-3' onClick={() => Toggle()}>
          Оформити
        </button>
      );
    }
    if (canBuy && !productIdsInCart.includes(productInfo.id)) {
      return (
        <button
          type='button'
          onClick={() => addProductToCart(productInfo, quantity)}
          className={`btn ${quantity > availableOrderQuantity(productInfo) ? 'btn-warning' : 'btn-outline-dark'} ml-3`}
        >
          {quantity > availableOrderQuantity(productInfo) ? 'Під замовлення' : 'Додати в кошик'}
        </button>
      );
    }
    return null;
  };

  if (!productInfo) {
    return <div>Завантаження сторінки...</div>;
  }

  return (
    <div className='container'>
      <Helmet>
        <title>{`Купити ${productInfo.name} з доставкою по Україні.`}</title>
        <meta name='description'
              content={`Купити ${productInfo.name} за ціною ${productInfo.discountedPrice} грн. Діє накопичувальна система знижок та безкоштовна доставка по Україні`} />

        {/* Open Graph метатеги */}
        <meta property='og:title' content={`Купити ${productInfo.name} з доставкою по Україні.`} />
        <meta property='og:description'
              content={`Купити ${productInfo.name} за ціною ${productInfo.discountedPrice} грн. Діє накопичувальна система знижок та безкоштовна доставка по Україні`} />
        <meta property='og:image'
              content={productInfo.imagePathList && productInfo.imagePathList.length > 0 ? `${BASE_URL}/api/v1/product/image/${productInfo.imagePathList[0]}` : ''} />
        <meta property='og:url' content={window.location.href} />
        <meta property='og:type' content='product' />
        <meta property='og:site_name'
              content='Wargame Shop - магазин мініатюр та аксесуарів для Warhammer, Vallejo, Forge World, Age of Sigmar, Kill Team, Warcry та інших систем.' />

        {/* Twitter метатеги */}
        <meta name='twitter:card' content='summary_large_image' />
        <meta name='twitter:title' content={`Купити ${productInfo.name} з доставкою по Україні.`} />
        <meta name='twitter:description'
              content={`Купити ${productInfo.name} за ціною ${productInfo.discountedPrice} грн. Діє накопичувальна система знижок та безкоштовна доставка по Україні`} />
        <meta name='twitter:image'
              content={productInfo.imagePathList && productInfo.imagePathList.length > 0 ? `${BASE_URL}/api/v1/product/image/${productInfo.imagePathList[0]}` : ''} />
        <meta name='twitter:url' content={window.location.href} />
      </Helmet>
      <div className='row'>
        <div className='col p-0'>
          <Header />
        </div>
      </div>

      <div className='row'>

        <div className='col-xl-6 col-lg-6 col-md-6 col-12 product-images-block'>
          <ProductDiscountImage as='div' price={productInfo.price} discountedPrice={productInfo.discountedPrice}
            personalDiscount={productInfo.personalDiscount} productDiscount={productInfo.productDiscount} className='product-gallery-discount-image'>
            <ProductImageGallery key={productInfo.id} items={carouselImages} showThumbnails={showThumbnails} />
          </ProductDiscountImage>
          {(productInfo.state === 'PREORDER' || productInfo.discountCategoryName === 'Webstore Exclusive GW') && (
            <div className={`product-gallery-badges${productInfo.discountCategoryName === 'Webstore Exclusive GW' ? '' : ' d-none d-lg-flex'}`}>
              {productInfo.state === 'PREORDER' && (
                <span className='badge badge-success product-badge d-none d-lg-block'>Передзамовлення</span>
              )}
              {productInfo.discountCategoryName === 'Webstore Exclusive GW' && (
                <span className='badge badge-secondary product-badge'>Webstore Exclusive</span>
              )}
            </div>
          )}
        </div>
        <div className='col-xl-6 col-lg-6 col-md-6 col-12'>
          <h4 className='font-weight-bold pt-5 mb-0'>{productInfo.name}</h4>
          <div className="d-flex align-items-center flex-wrap">
            <ProductStatus product={productInfo} />
            {user?.type === 'ADMIN' && (
              <div className="position-relative ml-auto d-none d-md-block" ref={statusDropdownRef}>
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm"
                  onClick={() => setShowStatusDropdown(prev => !prev)}
                  disabled={isUpdatingStatus}
                  title="Змінити статус товару"
                >
                  <i className="bi bi-pencil-fill text-dark mr-1" />
                  Статус
                  <i className={`bi bi-chevron-${showStatusDropdown ? 'up' : 'down'} ml-1`} />
                </button>
                {showStatusDropdown && (
                  <div
                    className="position-absolute border rounded bg-white shadow-sm mt-1"
                    style={{ zIndex: 1050, minWidth: 220, maxHeight: 280, overflowY: 'auto' }}
                  >
                    {PRODUCT_STATES_FOR_EDIT.map((s) => (
                      <div
                        key={s.value}
                        className="px-3 py-2 d-flex align-items-center"
                        style={{
                          cursor: 'pointer',
                          backgroundColor: productInfo.state === s.value ? '#e9ecef' : 'transparent'
                        }}
                        onMouseEnter={(e) => { if (productInfo.state !== s.value) e.currentTarget.style.backgroundColor = '#f8f9fa'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = productInfo.state === s.value ? '#e9ecef' : 'transparent'; }}
                        onClick={() => updateProductStatus(s.value)}
                      >
                        {productInfo.state === s.value && <i className="bi bi-check2 text-success mr-2" />}
                        <span>{s.label}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>

          <div className='row price-block bg-light pt-2'>
            <div className='col-xl-6 col-lg-6 col-12'>
              <div className='container-fluid d-flex p-0 pt-2'>
                {renderPrice()}
                {renderDiscountInfo(false)}
              </div>
              {renderDiscountInfo(true)}
            </div>

            <div className='col-xl-6 col-lg-6 col-12'>
              {renderBuyBlock()}
            </div>
            <div className='col-12'>
              {renderLoginInfo()}
            </div>
            <div className='col-12'>
              {renderFavoriteButton()}
            </div>
          </div>

          <hr className='hr-divider' />

          {productInfo.description !== undefined && productInfo.description !== '' ? (
            <div>
              <h6><strong>Опис і комплектація:</strong></h6>
              <div className='small'
                   dangerouslySetInnerHTML={{
                     __html: productInfo.description,
                   }}
              />
            </div>) : null}

          {productInfo.categories !== undefined ?
            <div className='font-weight-bold small pt-3'>Категорії:{' '}
              {productInfo.categories.map((category, index) => {
                const categoryName = category.name.replace(/<br\/>/g, '');
                return (
                  <span key={category.id}>
                    <Link to={'/boxes?categoryIds=' + category.id}>{categoryName}</Link>
                    {index < productInfo.categories.length - 1 && ', '}
                  </span>
                );
              })}
            </div>
            : null}
          {productInfo.code !== undefined && productInfo.code !== null ?
            <p className='small mb-0'><strong>Артикул: </strong>{productInfo.code}</p>
            : null}
          {isLoggedIn && productInfo.discountCategoryName && (
            <p className='small'><strong>Категорія для персональної знижки: </strong>{productInfo.discountCategoryName}
            </p>
          )}

          <div className='info-block pt-3'>
            <Tabs
              defaultActiveKey=''
              id='information-tabs'
              className='mb-3 product-page-info-tabs black-text'
            >
              <Tab eventKey='delivery' title='Доставка'>
                <div className='delivery-info small'>
                  <p><strong>Доставка:</strong></p>
                  <ol>
                    <li>
                      Доставка до відділення чи поштомату Нової Пошти.
                    </li>
                    <li>
                      Кур'єрська доставка Новою Поштою. При оформленні замовлення вкажіть адресу в полі "Коментар
                      до замовлення"
                    </li>
                    <li>
                      Доставка Укрпоштою. Здійснюється з затримкою в 1 робочий день
                    </li>
                  </ol>
                  <p><strong>Доставка є безкоштовною для покупця за умови покупки на суму більшу за 2000грн і повної
                    передплати</strong></p>
                  <p><strong>Відправка замовлення</strong> здійснюється в той же день (для відправок Новою Поштою), якщо
                    воно
                    зроблено не пізніше, ніж за 4год до кінця робочого дня. Актуальний графік роботи магазину
                    можна переглянути в шапці сайту. Замовлення укрпоштою відправляються з затримкою в 1 день</p>
                </div>
              </Tab>
              <Tab eventKey='payment' title='Оплата'>
                <div className='payment-info small'>
                  <p><strong>Оплата</strong> може бути здійснена наступними способами:</p>
                  <ul>
                    <li><strong>Оплата на банківський рахунок.</strong> У цьому випадку реквізити будуть надані
                      менеджером після обробки вашого замовлення
                    </li>
                    <li><strong>Післяплата на пошті.</strong> Оплата відбувається при отриманні у відділенні Нової
                      Пошти / Укрпошти. Службою доставка стягується додатковка комісія до 2%
                    </li>
                  </ul>
                </div>
              </Tab>
            </Tabs>
          </div>

        </div>
      </div>
      <hr />
      <div className='row'>
        <div className='col-12'>
        </div>
      </div>

      <div className='row p-0'>
        <div className='col p-0'>
          <Footer />
        </div>
      </div>
      <Basket showModal={showModal} close={Toggle} />
    </div>
  );
};

export default ProductPage;
